import api from "./api";

const BASE_ENDPOINT = '/valor-beneficio';

/**
 * Traz todos os valor-beneficio aplicando os filtros
 * @param {*} valorId  id do valor-beneficio
 * @example
 * filters = { filial: 1 }
 */
function getAllAndFilter(filters={}) {
    return api.get(
        `${BASE_ENDPOINT}/list`, 
        { params: {...filters} }
    );
}

/**
 * Traz os dados para valor-beneficio a partir do id de valor-beneficio
 * @param {*} valorId  id do valor-beneficio
 */
function getByValorId(valorId) {
    return api.get(`${BASE_ENDPOINT}/${valorId}`)
}

/** Cria um novo valor de benefício para uma filial no database */
function createNew(form) {
    return api.post(
        `${BASE_ENDPOINT}/create`,
        {...form}
    );
}

/**
 * Atualiza os valores de um benefício em uma filial
 * @param {*} id chave id do valor-beneficio
 * @param {*} form 
 */
function updateOne(id, form) {
    return api.put(`${BASE_ENDPOINT}/update/${id}`, { ...form })
}

const BeneficioApiService = {
    getAllAndFilter,
    getByValorId,
    createNew,
    updateOne,
}

export default BeneficioApiService;